export const removeAllWhitespaces = (value, originalValue) => {
    return value.replace(/\s/g, "");
};
